export class ApiError extends Error {
  public readonly status: number
  public readonly response: Response

  constructor(response: Response) {
    super(`API Error: ${response.status} ${response.statusText}`)
    this.name = "ApiError"
    this.status = response.status
    this.response = response
  }
}

export class NotAuthenticatedError extends Error {
  constructor() {
    super("Not authenticated")
    this.name = "NotAuthenticatedError"
  }
}
